module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/assessment_achievements/3_6ecaf75e3ea4f79698bc485fc81f9dd8.png";